/**
 * Arma las líneas de producto para /shipping/calculate.
 *
 * Acá NO va el flag `box` a propósito. Ese flag decide cómo se cuentan los
 * bultos y de ahí sale el costo del envío, así que lo resuelve el backend
 * contra el catálogo (ver ShippingController::conBultoDelCatalogo). Mandarlo
 * desde el navegador traía dos problemas:
 *
 *  - El carrito del cliente con sesión no incluía el campo, así que la línea
 *    viajaba sin el flag y el envío se cotizaba de menos. El invitado no, porque
 *    lo tomaba del producto del catálogo. La misma compra salía distinta según
 *    si la persona había iniciado sesión.
 *  - Un flag que el backend ignora, pero que igual se manda, hace creer que
 *    cambiarlo acá sirve de algo.
 *
 * El carrito sigue guardando `box` —es un dato del producto y se usa para
 * mostrarlo—, pero el precio no se decide en el navegador.
 */
export const mapProductsForShipping = (products = []) => {
    if (!Array.isArray(products)) {
        return [];
    }

    return products
        .filter((product) => product && (product.product_id || product.id || product.internal_id))
        .map((product) => ({
            id: product.product_id || product.id || product.internal_id,
            quantity: Number(product.quantity) > 0 ? Number(product.quantity) : 1,
        }));
};

/**
 * Config de axios para /shipping/calculate: manda el token del cliente si hay
 * sesión (task-1821).
 *
 * El backend sólo informa las opciones de envío del convenio de descuento
 * (retiro en tienda, retiro exclusivo, envío gratis invalidado) a su dueño, y
 * al dueño lo identifica el token, no el user_email del cuerpo. Sin el token,
 * un cliente con convenio vería el envío normal en vez de "Retiro en tienda".
 */
export const shippingRequestConfig = () => {
    if (typeof window === 'undefined') {
        return {};
    }

    const token = localStorage.getItem('auth_token');
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const getShippingProductsFromStorage = () => {
    if (typeof window === 'undefined') {
        return [];
    }

    const products = JSON.parse(localStorage.getItem('products_cart')) || [];
    return mapProductsForShipping(products);
};

export const getShippingOrderAmountFromStorage = () => {
    if (typeof window === 'undefined') {
        return 0;
    }

    const products = JSON.parse(localStorage.getItem('products_cart')) || [];

    return products.reduce((total, product) => {
        const price = Number(product.sale_price || product.price || 0);
        const quantity = Number(product.quantity) > 0 ? Number(product.quantity) : 1;

        return total + (price * quantity);
    }, 0);
};
